import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export function useUsage() {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/usage");
      setUsage(r.data);
    } catch {
      // silent — endpoint requires auth
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { usage, loading, refresh };
}

// -1 = unlimited
export function usageBar(current, limit) {
  if (limit === -1) return { pct: 0, unlimited: true, over: false };
  if (!limit || limit <= 0) return { pct: 0, unlimited: false, over: false };
  const pct = Math.min(100, Math.round((current / limit) * 100));
  return { pct, unlimited: false, over: current >= limit, near: pct >= 80 };
}
